export const CONTRACTS_ROUTER_NAMES = {
  ITEMS: "contracts-items",
  EDIT: "contracts-edit",
  CREATE: "contracts-create",
  CREATE_AGREEMENT: "contracts-create-agreement",
};

export const CONTRACTS_ROUTER_PATHS = {
  ITEMS: "/contracts",
  EDIT: "/contracts/:id",
  CREATE: "/contracts/create",
  CREATE_AGREEMENT: "/contracts/create-agreement/:parentId",
};
